<app-message-service
  [id]="messageId"
  [severity]="severityMessage"
  [summaryMessage]="summaryMessage"
  [detailMessage]="detailMessage"></app-message-service>
<div class="p-3 md:container md:mx-auto bg-lightest md:pb-0 pb-28">
  <div class="flex items-center md:items-start md:ml-1 md:flex-col md:mt-32 md:mb-6">
    <div
      class="back flex md:ml-1 md:inline"
      *ngIf="showChangePassword">
      <button
        pButton
        class="back-accueil font-app-medium"
        (click)="resetView()">
        <i class="pi pi-arrow-left mr-4"></i>
        <span class="md:inline hidden">{{ "userProfile.title" | translate }}</span>
      </button>
    </div>
    <div class="title">
      <h1 class="flex flex-row text-xl md:text-2xl font-app-bold mb-5 md:mb-10 md:ml-1 md:-mt-20 p-1">
        {{ !showChangePassword ? ("userProfile.title" | translate) : ("changePassword.title" | translate) }}
      </h1>
    </div>
  </div>

  <div class="informations border-light border rounded-lg bg-white p-8">
    <div *ngIf="!showChangePassword">
      <div class="flex items-center justify-between mb-6">
        <h1 class="font-app-bold text-xl">
          {{ "userProfile.generalInfo" | translate }}
        </h1>
      </div>
      <hr class="text-lightest" />
    </div>
    <app-user-info
      *ngIf="!showChangePassword"
      [member]="member"
      [isEditMode]="isEditing"
      (changePasswordToggle)="onChangePasswordToggle($event)"></app-user-info>
    <app-change-password
      *ngIf="showChangePassword"
      [member]="member"
      (changePasswordToggle)="onChangePasswordToggle($event)"></app-change-password>
  </div>
  <app-user-address
    *ngIf="!showChangePassword"
    [member]="member"
    [isEditMode]="isEditing"
    [isFirstContract]="isFirstContract"></app-user-address>
  <app-user-consent
    *ngIf="!showChangePassword"
    [member]="member"
    [isEditMode]="isEditing"
    [isFirstContract]="isFirstContract"></app-user-consent>
  <div
    *ngIf="!showChangePassword"
    class="mt-4 md:mb-10">
    <button
      *ngIf="!isEditing && member?.canUpdateMember && !isPartner() && false"
      class="bg-primary text-white p-3 rounded-md shadow-md hover:bg-primary-600 transition duration-200 ease-in-out mb-5 font-bold w-full md:w-max"
      pTooltip="Modifier mon profil"
      tooltipPosition="bottom"
      (click)="toggleEditing()">
      <span class="md:px-16">{{ "userProfile.modifyProfile" | translate }}</span>
    </button>

    <div
      *ngIf="isEditing"
      class="flex flex-col md:flex-row items-center md:space-x-4 space-y-4 md:space-y-0">
      <!-- Cancel Button (Annuler) -->
      <div class="w-full mt-4 md:w-auto md:mt-0 order-2 md:order-1">
        <button
          class="border border-primary text-primary w-full md:w-auto py-2 px-6 rounded-md shadow-none hover:bg-primary-50 transition duration-200 ease-in-out font-app-regular"
          pTooltip="Annuler"
          tooltipPosition="bottom"
          (click)="toggleEditing()">
          <span class="px-16">{{ "changePassword.cancelBtn" | translate }}</span>
        </button>
      </div>

      <!-- Confirm Button (Valider) -->
      <div class="w-full md:w-auto order-1 md:order-2">
        <button
          class="bg-primary text-white w-full md:w-auto py-2 px-6 rounded-md shadow-none hover:bg-primary-600 transition duration-200 ease-in-out font-app-regular"
          pTooltip="Valider"
          tooltipPosition="bottom"
          (click)="submit()">
          <span class="px-16">{{ "changePassword.submitBtn" | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
<app-profil-edition
  *ngIf="visibleProfilEditionDialog"
  [visibleDialog]="visibleProfilEditionDialog"
  (dialogEmitter)="onContractEditionClose()"
  (emitUpdateValidation)="onUpdateValidation($event)">
</app-profil-edition>
